import {
  createPointOfSaleCategoryAPI,
  deletePointOfSaleCategoryAPI,
  getAssociationsStatesAPI,
  getCountriesAPI,
  getExchangesAPI,
  getPointsOfSaleCategoriesAPI,
  updatePointOfSaleCategoryAPI,
} from 'api/endpoints/general/general.api';
import * as GeneralTypes from './general.types';
import {
  IAssociationsStates,
  ITranslate,
  TAssociation,
} from 'interfaces/general.interface';
import * as status from 'interfaces/general.interface';
import { messageError, messageSuccess, messageWarning } from 'views/components/message';
import { TgeneralDispatchReducer } from './general.reducer';
import {
  ICreatePointOfSaleCategoryAPIRequestBody,
  IUpdatePointOfSaleCategoryAPIRequestBody,
} from 'api/endpoints/general/general.response.interface';

export async function getExchangesAction({
  dispatch,
  translate,
  token,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  translate: ITranslate;
  token: string;
}) {
  try {
    const exchangesFetch = await getExchangesAPI({ token });
    if (exchangesFetch.response.status === 200) {
      return dispatch({
        type: GeneralTypes.SET_EXCHANGES,
        payload: exchangesFetch.data,
      });
    } else {
      console.log('error', 'Error al obtener los tipos de monedas.');
      // messageError('Error al obtener los tipos de monedas.')
      // return notificationErr(clientsError.get_exchanges_002, translate)
    }
  } catch (err) {
    console.log('error', err);
    // messageError('Error al obtener los tipos de monedas.')
    // return notificationErr(clientsError.get_exchanges_001, translate)
  }
}

export async function getCountriesAction({
  dispatch,
  translate,
  token,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  translate: Function;
  token: string;
}) {
  try {
    const getCountriesFetch = await getCountriesAPI({ token });
    if (getCountriesFetch.response.status === 200) {
      dispatch({
        type: GeneralTypes.SET_COUNTRIES,
        payload: getCountriesFetch.data,
      });
    }
  } catch (error) {
    messageError('Error al obtener los paises.');
    console.log(error);
  }
}

export async function getAssociationStatesAction({
  dispatch,
  translate,
  token,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  translate: Function;
  token: string;
}) {
  let stateValues: IAssociationsStates = {
    pending: {} as TAssociation,
    connected: {} as TAssociation,
    rejected: {} as TAssociation,
    disconnected: {} as TAssociation,
  };

  try {
    const [associationStatesFetch] = await Promise.all([
      getAssociationsStatesAPI({ token }),
    ]);
    if (
      !associationStatesFetch?.response ||
      associationStatesFetch?.response?.status !== 200 ||
      !associationStatesFetch.data ||
      associationStatesFetch?.data?.length === 0
    ) {
    } else {
      for (const state of associationStatesFetch.data) {
        if (state.state === status.pending) {
          stateValues.pending = state;
        }
        if (state.state === status.connected) {
          stateValues.connected = state;
        }
        if (state.state === status.rejected) {
          stateValues.rejected = state;
        }
        if (state.state === status.disconnected) {
          stateValues.disconnected = state;
        }
      }
      dispatch({ type: GeneralTypes.SET_ASSOCIATIONS_STATES, payload: stateValues });
    }
  } catch (err) {
    console.log('error', err);
    messageError('Error al obtener los estados de las asociaciones.');
  }
}

export async function getPointsOfSaleCategoriesAction({
  dispatch,
  token,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  token: string;
}) {
  try {
    dispatch({
      type: GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES,
      payload: true,
    });
    const getPointsOfSaleCategoriesFetch = await getPointsOfSaleCategoriesAPI({ token });
    if (getPointsOfSaleCategoriesFetch.response.status === 200) {
      dispatch({
        type: GeneralTypes.SET_POINTS_OF_SALE_CATEGORIES,
        payload: getPointsOfSaleCategoriesFetch.data.sort(
          (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        ),
      });
    }
  } catch (error) {
    messageError('Error al obtener las categorias de puntos de venta.');
    console.log(error);
  } finally {
    dispatch({
      type: GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES,
      payload: false,
    });
  }
}

export async function createCategoryAction({
  dispatch,
  token,
  body,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  token: string;
  body: ICreatePointOfSaleCategoryAPIRequestBody;
}): Promise<boolean> {
  try {
    dispatch({ type: GeneralTypes.IS_LOADING_CREATE_CATEGORY, payload: true });
    const createCategoryFetch = await createPointOfSaleCategoryAPI({ body, token });
    if (
      createCategoryFetch.response.status === 200 ||
      createCategoryFetch.response.status === 201
    ) {
      dispatch({
        type: GeneralTypes.CREATE_CATEGORY,
        payload: createCategoryFetch.data,
      });
      messageSuccess('Categoria de punto de venta creada correctamente.');
      return true;
    }
    if (createCategoryFetch.response.status === 409) {
      messageWarning('Ya existe una categoria de punto de venta con ese nombre.');
      return false;
    }
    messageError('Error al crear la categoria de punto de venta.');
    return false;
  } catch (error) {
    messageError('Error al crear la categoria de punto de venta.');
    return false;
  } finally {
    dispatch({ type: GeneralTypes.IS_LOADING_CREATE_CATEGORY, payload: false });
  }
}

export async function updateCategoryAction({
  dispatch,
  token,
  body,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  token: string;
  body: IUpdatePointOfSaleCategoryAPIRequestBody;
}): Promise<boolean> {
  try {
    dispatch({ type: GeneralTypes.IS_LOADING_UPDATE_CATEGORY, payload: true });
    const updateCategoryFetch = await updatePointOfSaleCategoryAPI({ body, token });
    if (
      updateCategoryFetch.response.status === 200 ||
      updateCategoryFetch.response.status === 201
    ) {
      dispatch({
        type: GeneralTypes.UPDATE_CATEGORY,
        payload: updateCategoryFetch.data,
      });
      messageSuccess('Categoria de punto de venta actualizada correctamente.');
      return true;
    }
    if (updateCategoryFetch.response.status === 409) {
      messageWarning('Ya existe una categoria de punto de venta con ese nombre.');
      return false;
    }
    messageError('Error al actualizar la categoria de punto de venta.');
    return false;
  } catch (error) {
    messageError('Error al actualizar la categoria de punto de venta.');
    return false;
  } finally {
    dispatch({ type: GeneralTypes.IS_LOADING_UPDATE_CATEGORY, payload: false });
  }
}

export async function deleteCategoryAction({
  dispatch,
  token,
  categoryId,
}: {
  dispatch: React.Dispatch<TgeneralDispatchReducer>;
  token: string;
  categoryId: string;
}): Promise<boolean> {
  try {
    dispatch({
      type: GeneralTypes.IS_LOADING_DELETE_CATEGORY,
      payload: {
        categoryId,
        isLoading: true,
      },
    });
    const deleteCategoryFetch = await deletePointOfSaleCategoryAPI({
      categoryId,
      token,
    });
    if (deleteCategoryFetch.response.status === 200) {
      dispatch({
        type: GeneralTypes.DELETE_CATEGORY,
        payload: categoryId,
      });
      messageSuccess('Categoria de punto de venta eliminada correctamente.');
      return true;
    }
    messageError('Error al eliminar la categoria de punto de venta.');
    return false;
  } catch (error) {
    messageError('Error al eliminar la categoria de punto de venta.');
    return false;
  } finally {
    dispatch({
      type: GeneralTypes.IS_LOADING_DELETE_CATEGORY,
      payload: {
        categoryId: '',
        isLoading: false,
      },
    });
  }
}
